// Overview: two independent entry points into the project.
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/reading.css";
import { mountBudgetSketch } from "./components/budget-sketch";
import { markActiveNav } from "./components/chrome";
import { renderComicReader } from "./components/comic-reader";
import { mountLessonCards } from "./components/lesson-cards";
import { mountMedia } from "./components/media-player";
markActiveNav();
mountMedia();
mountLessonCards();
for (const mount of document.querySelectorAll<HTMLElement>(
  "[data-component='budget-sketch']",
)) {
  mountBudgetSketch(mount);
}
for (const mount of document.querySelectorAll<HTMLElement>(
  "[data-component='comic-reader']",
)) {
  renderComicReader(mount);
}
